import { z } from 'zod';

const ForgotPasswordFormSchema = z.object({
  email: z.string().email({ message: 'The email must be a valid email address' })
});
type ForgotPasswordFormType = z.infer<typeof ForgotPasswordFormSchema>;

export { ForgotPasswordFormSchema };
export type { ForgotPasswordFormType };
